import {useLazyQuery} from "@apollo/client";
import {ForwardedRef, forwardRef} from "react";
import {SelectInstance} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectComponent, SelectProps} from "@/components/select/Select.types.ts";
import {useLoadOptions} from "@/lib/hooks/useLoadOptions.ts";
import {GQL_MONITORING_SERVICE_TYPES, MonitoringServiceTypesResponse} from "@/lib/queries/checks.ts";
import {ServiceType} from "@/lib/types/checks.ts";

export const CheckTypeSelect = forwardRef(
  ({options, ...props}: SelectProps<ServiceType>, ref: ForwardedRef<SelectInstance<ServiceType>>) => {
    const [getMonitoringServiceTypes] = useLazyQuery<MonitoringServiceTypesResponse>(GQL_MONITORING_SERVICE_TYPES);
    const {options: monitoringServiceTypes, isLoading} = useLoadOptions<
      ServiceType,
      MonitoringServiceTypesResponse,
      true
    >({
      options: options,
      fetchOptions: getMonitoringServiceTypes,
      transform: (result) => {
        const monitoringServiceTypes = result.data?.monitoringServiceTypes || [];
        return monitoringServiceTypes.map((serviceGroup) => ({
          label: serviceGroup.group,
          options: serviceGroup.types,
        }));
      },
    });

    return (
      <Select
        isLoading={isLoading}
        options={monitoringServiceTypes}
        getOptionLabel={(t: ServiceType) => t.display}
        getOptionValue={(t: ServiceType) => t.name}
        {...props}
        ref={ref}
      />
    );
  }
) as SelectComponent;
